exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vux-emotion,.vux-static-emotion{display:inline-block}.vux-static-emotion{width:24px;height:24px}", ""]);

// exports
